import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ShieldAlert, Clock } from "lucide-react";

export default function AdminModeration() {
  const { data: flags, isLoading } = useQuery({
    queryKey: ["admin-chat-flags"],
    queryFn: async () => (await api.get("/admin/chat/flags")).data,
    refetchInterval: 10000,
  });

  return (
    <div data-testid="admin-moderation">
      <div className="flex items-center gap-2 mb-1">
        <ShieldAlert className="h-5 w-5 text-red-400" />
        <h1 className="font-display text-2xl text-white tracking-[0.08em]">CHAT MODERATION</h1>
      </div>
      <p className="text-sm text-white/50 mb-6">Hate-speech violations are auto-blocked and the author is muted (escalating one minute per offense). Ordinary profanity is allowed.</p>

      {isLoading ? (
        <div className="text-white/40 py-10 text-center">Loading flags…</div>
      ) : (flags || []).length === 0 ? (
        <div className="hud-pill rounded-2xl p-10 text-center text-white/40">No violations flagged. The lobby is behaving.</div>
      ) : (
        <div className="space-y-2">
          {flags.map((f) => (
            <div key={f.id} data-testid={`chat-flag-${f.id}`} className="hud-pill rounded-xl p-4 flex flex-wrap items-start gap-3 border border-red-400/15">
              <div className="h-9 w-9 rounded-lg bg-red-500/15 border border-red-400/30 flex items-center justify-center shrink-0">
                <ShieldAlert className="h-4 w-4 text-red-400" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-white font-medium text-sm">{f.user_name}</span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">{f.channel}</span>
                  <span className="font-mono text-[10px] text-red-300/80">offense #{f.offense_count} · muted {f.ban_minutes}m</span>
                  {f.currently_muted_seconds > 0 && (
                    <span className="font-mono text-[10px] text-amber-300 inline-flex items-center gap-1"><Clock className="h-3 w-3" /> muted {f.currently_muted_seconds}s now</span>
                  )}
                </div>
                <div className="mt-1 text-white/70 text-sm break-words bg-black/30 rounded px-2 py-1 border border-white/5">"{f.text}"</div>
                <div className="mt-1 font-mono text-[10px] text-white/35">matched: {f.matched} · {new Date(f.created_at).toLocaleString()} · total offenses: {f.total_offenses}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
